// Política de links do site (contrato do conteúdo Tiptap 1.0, seção 2.3: a decisão é do site).
// - reprovado no safeUrl → null (o renderer mostra só o texto)
// - mailto:, tel: e relativos sem barra (`#topo`, `x/y`) → link comum
// - mesmo host do site (com ou sem www, http ou https) → navegação interna, exceto arquivo (extensão no caminho)
// - outro host, inclusive `//host` → externo
import { isSafeUrl, urlScheme } from './safeUrl'

const FILE = /\.[a-z][a-z0-9]{1,4}$/i

// Hostname sem um `www.` inicial (case-insensitive: `URL` já normaliza para minúsculas)
const bareHost = hostname => hostname.replace(/^www\./, '')

export const resolveLink = (href, origin) => {
	if (!isSafeUrl(href)) return null
	const value = href.trim()
	const scheme = urlScheme(value)
	if ([ 'mailto', 'tel' ].includes(scheme)) return { kind: 'plain', href: value }
	if (!scheme && !/^[\\/]/.test(value)) return { kind: 'plain', href: value }
	let url
	try {
		url = new URL(value, origin)
	} catch {
		return null
	}
	const site = new URL(origin)
	const sameSite = [ 'http:', 'https:' ].includes(url.protocol) && bareHost(url.hostname) === bareHost(site.hostname) && url.port === site.port
	if (!sameSite) return { kind: 'external', href: url.href }
	const path = url.pathname + url.search + url.hash
	return FILE.test(url.pathname) ? { kind: 'plain', href: path } : { kind: 'router', to: path }
}
